import { Loader } from "@/components";
import { Button, Grid } from "@mui/material";
import { useState } from "react";
import { getDrugReport, getLogReport } from "../api/admins";
import CustomizedHook from "../components/project/autocomplatePro";
import ReportFilter from "../components/reports/reportFilter";

export default function Reports({ group }) {
  const [selectedType, setSelectedType] = useState();
  const [buttonStatus, setButtonStatus] = useState("levelOne");
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Grid width={"100%"} display="flex" flexDirection={"column"} gap={"20px"}>
        <CustomizedHook
          width={"100%"}
          maxWidth={"100%"}
          parentWidth={"100%"}
          placeholder={"انتخاب کنید."}
          label="نوع گزارش"
          options={[
            { name: "گزارشات کلی اردوها", value: "1" },
            { name: "گزارشات عملکرد داروخانه اردو", value: "2" },
            { name: "گزارش جامع تجویز دارو به بیماران", value: "3" },
            { name: "گزارش مدیریتی انبار دارویی گروه‌ها", value: "4" },
            { name: "گزارش انبارگردانی داروها", value: "5" },
          ]}
          onChange={(_, newValue) => {
            setButtonStatus("levelOne");
            setSelectedType(newValue);
          }}
        />
        {buttonStatus === "levelOne" && (
          <Button
            variant="contained"
            color="primary"
            disabled={loading || selectedType?.value === undefined}
            style={{
              width: "150px",
            }}
            onClick={() => {
              setLoading(true);
              if (selectedType?.value === "5") {
                getLogReport()
                  .then((x) => {
                    const blob = new Blob([x], {
                      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "گزارش انبارگردانی داروها.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                  })
                  .finally(() => setLoading(false));
              }
              if (selectedType?.value === "4") {
                getDrugReport()
                  .then((x) => {
                    const blob = new Blob([x], {
                      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "گزارش مدیریتی انبار دارویی گروه ها.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                  })
                  .catch(() => {})
                  .finally(() => setLoading(false));
              }
              if (
                selectedType?.value === "1" ||
                selectedType?.value === "2" ||
                selectedType?.value === "3"
              ) {
                setButtonStatus("levelTwo");
                setLoading(false);
              }
            }}
          >
            مرحله بعد
          </Button>
        )}

        {buttonStatus === "levelTwo" && (
          <ReportFilter group={group} typeId={selectedType?.value} />
        )}
      </Grid>

      {loading && <Loader />}
    </>
  );
}
